/**
 * ITL Golf — Buy 3, Get 1 Free Promo Counter
 * Persists across all Shopify AJAX cart re-renders.
 * Loaded once via custom-header.liquid.
 */
(function () {
  'use strict';

  var EXCLUDED_KEYWORDS = ['wallet', 'kit', 'duffle', 'strap', 'belt'];

  function isGloveItem(item) {
    var t = (item.title || '').toLowerCase();
    var h = (item.handle || item.url || '').toLowerCase();
    var p = (item.product_type || '').toLowerCase();
    var hasGlove = t.indexOf('glove') > -1 || h.indexOf('glove') > -1 || p === 'glove' || p === 'gloves';
    if (!hasGlove) return false;
    for (var i = 0; i < EXCLUDED_KEYWORDS.length; i++) {
      if (t.indexOf(EXCLUDED_KEYWORDS[i]) > -1) return false;
    }
    return true;
  }

  function updateAllBoxes(gloveCount) {
    var boxes = document.querySelectorAll('.itl-cart-promo-box');
    if (!boxes.length) return;

    var mod = gloveCount % 4;
    var unlocked = (mod === 0 && gloveCount >= 4);
    var pct = 0;
    if (mod === 1) pct = 25;
    else if (mod === 2) pct = 50;
    else if (mod === 3) pct = 75;
    else if (unlocked) pct = 100;

    var badgeText, copyHTML, ctaText, ctaVisible;

    if (unlocked) {
      badgeText = '4/4 free glove applied';
      copyHTML = '<strong>Promotion applied.</strong> Your 4th glove will be discounted to free at checkout.';
      ctaVisible = false;
      ctaText = '';
    } else if (mod === 3) {
      badgeText = '3/4 gloves';
      copyHTML = '<strong>Almost there.</strong> Add 1 more glove to receive your 4th glove free.';
      ctaText = 'Add 4th glove';
      ctaVisible = true;
    } else if (mod === 2) {
      badgeText = '2/4 gloves';
      copyHTML = 'Add 2 more gloves to receive your 4th glove free.';
      ctaText = 'Browse gloves';
      ctaVisible = true;
    } else if (mod === 1) {
      badgeText = '1/4 gloves';
      copyHTML = 'Add 3 more gloves to receive your 4th glove free.';
      ctaText = 'Browse gloves';
      ctaVisible = true;
    } else {
      badgeText = '0/4 gloves';
      copyHTML = 'Buy any 3 gloves and get your 4th glove free, automatically applied at checkout.';
      ctaText = 'Browse gloves';
      ctaVisible = true;
    }

    boxes.forEach(function (box) {
      box.dataset.gloveCount = gloveCount;

      var badge = box.querySelector('.itl-cart-promo-badge');
      if (badge) {
        badge.textContent = badgeText;
        badge.classList.toggle('is-unlocked', unlocked);
      }

      var bar = box.querySelector('.itl-cart-promo-bar-fill');
      if (bar) bar.style.width = pct + '%';

      var copy = box.querySelector('.itl-cart-promo-copy');
      if (copy) copy.innerHTML = copyHTML;

      var cta = box.querySelector('.itl-cart-promo-cta');
      var btn = box.querySelector('.itl-cart-promo-btn');
      if (cta) cta.style.display = ctaVisible ? '' : 'none';
      if (btn && ctaText) btn.textContent = ctaText;
    });
  }

  function fetchCartAndUpdate() {
    fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var count = 0;
        (cart.items || []).forEach(function (item) {
          if (isGloveItem(item)) count += item.quantity;
        });
        updateAllBoxes(count);
      })
      .catch(function () {});
  }

  // Debounce to prevent rapid-fire calls
  var debounceTimer = null;
  function debouncedFetch() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(fetchCartAndUpdate, 250);
  }

  // --- Hook 1: Shopify PubSub (fires on all cart mutations) ---
  function hookPubSub() {
    if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, debouncedFetch);
      return true;
    }
    return false;
  }

  // --- Hook 2: Watch cart icon bubble text (qty badge change = cart changed) ---
  function watchCartBubble() {
    var bubble = document.getElementById('cart-icon-bubble');
    if (!bubble) return;
    var lastText = bubble.textContent;
    new MutationObserver(function () {
      var nowText = bubble.textContent;
      if (nowText !== lastText) {
        lastText = nowText;
        debouncedFetch();
      }
    }).observe(bubble, { childList: true, subtree: true, characterData: true });
  }

  // --- Hook 3: Watch for new promo boxes injected by AJAX section re-renders ---
  var bodyObserver = new MutationObserver(function (mutations) {
    var found = false;
    for (var m = 0; m < mutations.length; m++) {
      var nodes = mutations[m].addedNodes;
      for (var n = 0; n < nodes.length; n++) {
        var node = nodes[n];
        if (node.nodeType !== 1) continue;
        if (node.classList && node.classList.contains('itl-cart-promo-box')) { found = true; break; }
        if (node.querySelector && node.querySelector('.itl-cart-promo-box')) { found = true; break; }
      }
      if (found) break;
    }
    if (found) debouncedFetch();
  });

  function init() {
    // Initial paint from server-rendered glove count
    var firstBox = document.querySelector('.itl-cart-promo-box');
    if (firstBox) {
      var serverCount = parseInt(firstBox.dataset.gloveCount || '0', 10);
      updateAllBoxes(serverCount);
    }

    // Verify with live cart data
    fetchCartAndUpdate();

    // Wire up all event hooks
    if (!hookPubSub()) {
      window.addEventListener('load', hookPubSub);
    }
    watchCartBubble();

    bodyObserver.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
